app.frameit = function() {
    
    var element = jQuery('.add-to-links').detach();
    jQuery('.product-shop').append('test');
    alert('test');

  
};